import React from 'react';
import { useMutation } from '@apollo/client';
import DisconnectWearableMutation from './DisconnectWearableMutation';
import WearableConnectionsQuery from '../Fetch/WearableConnectionsQuery';

export type WearableMutationResult =
  | { ok: true }
  | { ok: false; reason: 'network' | 'server'; message: string };

interface Result {
  disconnectProvider: (providerKey: string) => Promise<WearableMutationResult>;
  loading: boolean;
}

interface Props {
  children: (result: Result) => React.ReactElement;
}

const DisconnectWearableConnectorApollo: React.FC<Props> = ({ children }) => {
  const [mutate, { loading }] = useMutation(DisconnectWearableMutation, {
    refetchQueries: [{ query: WearableConnectionsQuery }],
  });

  const disconnectProvider = async (providerKey: string): Promise<WearableMutationResult> => {
    try {
      const response = await mutate({ variables: { provider: providerKey } });
      const payload = response.data?.wearable?.disconnectProvider;

      if (payload?.__typename === 'BasicMutationSuccess') {
        return { ok: true };
      }

      const message =
        payload?.description || payload?.name || payload?.code || 'wearable_disconnect_error';
      return { ok: false, reason: 'server', message };
    } catch (error) {
      const message = error instanceof Error ? error.message : 'wearable_disconnect_network_error';
      return { ok: false, reason: 'network', message };
    }
  };

  return children({ disconnectProvider, loading });
};

export default DisconnectWearableConnectorApollo;
